// eslint-disable-next-line sonarjs/regex-complexity
const validIpAddress = /^\b(?:(?:25[0-5]|2[0-4]\d|[01]?\d{1,2})\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d{1,2})\b$/;
const validMacAddress = /^([\dA-Fa-f]{2}[:-]){5}([\dA-Fa-f]{2})$/;

export { validIpAddress, validMacAddress };
